import FlexSection from "@/partials/sections/Section/FlexSection";
import NavbarProfile from "./components/NavbarProfile";
import NavbarAuth from "./components/NavbarAuth";

export default function NavbarEnd({
  customer,
  navbarToggle,
  showNavDd,
  logout,
}) {
  return (
    <div className="hidden lg:block order-3">
      <FlexSection extraClass={"justify-center items-center gap-8"}>
        {customer ? (
          <NavbarProfile
            customer={customer}
            logout={logout}
            navbarToggle={navbarToggle}
            showNavDd={showNavDd}
          />
        ) : (
          <NavbarAuth customer={customer} />
        )}
      </FlexSection>
    </div>
  );
}
